// extracted by mini-css-extract-plugin
export var background = "WebQuoteModalContentWithImage-module--background--be793";
export var boxWrapper = "WebQuoteModalContentWithImage-module--box-wrapper--07d13";
export var content = "WebQuoteModalContentWithImage-module--content--941f9";
export var context = "WebQuoteModalContentWithImage-module--context--b216c";
export var dates = "WebQuoteModalContentWithImage-module--dates--31579";
export var image = "WebQuoteModalContentWithImage-module--image--b7360";
export var ship = "WebQuoteModalContentWithImage-module--ship--9d0ac";
export var title = "WebQuoteModalContentWithImage-module--title--e7036";